import BaseEvent from './base_event';
import TutorialEvent from './tutorial_event'

export default class IntroEvent extends BaseEvent {
    static canOccur(gameState) { return !gameState.eventsResults.tutorial; }

    enter(gameState) {
        let skipped = false;
        game.time.events.add(10*1000, () => {
            if(!skipped) {
            this.schedule(TutorialEvent, 0);
            this.end();
            }
        })
        this.ui.showDialog({
            message: "Somewhere in the\nouter space..",
            gif: "assets/intro.gif",
            gifOffset: { x: -143, y: -125 },
            options: [{ text: "Skip" }]
        }, () => {
            skipped = true;
            this.schedule(TutorialEvent, 0);
            this.end();
        })
    }
}


// WEBPACK FOOTER //
// ./src/states/events/intro_event.js